const products = [
  {
    id: 1,
    productName: "3rd Age Pickaxe",
    price: 1500.5,
    oldPrice: 1600.0,
    description:
      "A legendary tool for miners, highly sought after for its exceptional durability and efficiency. It allows for faster resource gathering and unique material acquisition. This pickaxe is a must-have for serious adventurers.",
    imageUrl: "3er-age-pickaxe.png",
    inStock: true,
    onSale: true,
    urlGame: "3er-age-pickaxe.png",
  },
  {
    id: 2,
    productName: "Any In Game Fish",
    price: 25.75,
    oldPrice: 28,
    description: "Fresh fish for your adventures.",
    imageUrl: "any-in-game-fish.png",
    inStock: true,
    onSale: true,
    urlGame: "any-in-game-fish.png",
  },
  {
    id: 3,
    productName: "Any Region Any Server Dragonfight",
    price: 2300.0,
    oldPrice: 2450.32,
    description:
      "Dominate any dragon, anywhere. Experience epic battles and claim unique rewards in challenging encounters across all server regions. Prove your might against the most formidable foes.",
    imageUrl: "any-region-any-server-dragonfight.png",
    inStock: true,
    onSale: true,
    urlGame: "any-region-any-server-dragonfight.png",
  },
  {
    id: 4,
    productName: "Blue Partyhat",
    price: 1799.99,
    oldPrice: 1955.0,
    description: "A rare blue party hat.",
    imageUrl: "blue-partyhat.png",
    inStock: true,
    onSale: true,
    urlGame: "blue-partyhat.png",
  },
  {
    id: 5,
    productName: "Christmas Cracker",
    price: 999.99,
    oldPrice: 0,
    description:
      "Festive surprises in this cracker. Unwrap a piece of holiday magic with random, rare items that could boost your collection. Perfect for festive celebrations and special occasions.",
    imageUrl: "christmas-cracker.png",
    inStock: true,
    onSale: false,
    urlGame: "christmas-cracker.png",
  },
  {
    id: 6,
    productName: "Clean Mr Fuzzy Mascot Suit",
    price: 750.0,
    oldPrice: 0,
    description: "Immaculate mascot costume.",
    imageUrl: "clean-mr-fuzzy-mascot-suit.png",
    inStock: true,
    onSale: false,
    urlGame: "clean-mr-fuzzy-mascot-suit.png",
  },
  {
    id: 7,
    productName: "Dormant Infineon Dragon Egg",
    price: 2000.5,
    oldPrice: 2200.0,
    description:
      "A dormant dragon egg. Great mystery! Discover the potential within this ancient artifact. What legendary creature will emerge from its depths? An enigma waiting to be solved.",
    imageUrl: "dormant-infineon-dragon-egg.png",
    inStock: true,
    onSale: true,
    urlGame: "dormant-infineon-dragon-egg.png",
  },
  {
    id: 8,
    productName: "Dragon Ball Z Budokai Tenkaichi 3",
    price: 52.34,
    oldPrice: 0,
    description: "Classic Dragon Ball fighting game.",
    imageUrl: "dragon-ball-z-budokai-tenkaichi-3.webp",
    inStock: true,
    onSale: false,
    urlGame: "dragon-ball-z-budokai-tenkaichi-3.webp",
  },
  {
    id: 9,
    productName: "Fallout Sent Ap Heavy Box Armor",
    price: 1199.99,
    oldPrice: 1250.0,
    description:
      "Heavy armor for the apocalypse. Provides superior protection against various threats, enhancing your survival chances in desolate wasteland environments. Built for extreme conditions.",
    imageUrl: "fallout-sent-ap-heavy-box-armor.png",
    inStock: true,
    onSale: true,
    urlGame: "fallout-sent-ap-heavy-box-armor.png",
  },
  {
    id: 10,
    productName: "Glove Case",
    price: 15.0,
    oldPrice: 19.99,
    description: "Mysterious case with exclusive gloves.",
    imageUrl: "glove-case.png",
    inStock: true,
    onSale: true,
    urlGame: "glove-case.png",
  },
  {
    id: 11,
    productName: "Jah Rune",
    price: 300.0,
    oldPrice: 345.0,
    description:
      "Ancient rune of great power. Infuse your gear with formidable magical properties and enhance your combat prowess. Essential for high-level enchantments and crafting.",
    imageUrl: "jah-rune.png",
    inStock: true,
    onSale: true,
    urlGame: "jah-rune.png",
  },
  {
    id: 12,
    productName: "Operation Hydra Case Key",
    price: 5.0,
    oldPrice: 8.0,
    description: "Key for the Hydra case.",
    imageUrl: "operation-Hydra-Case-Key.png",
    inStock: true,
    onSale: true,
    urlGame: "operation-Hydra-Case-Key.png",
  },
  {
    id: 13,
    productName: "Operation Phoenix Weapon Case",
    price: 8.57,
    oldPrice: 14.99,
    description:
      "Weapon case from Operation Phoenix. Contains a variety of rare and high-tier weaponry, ready to unleash devastating power on your enemies. A must-have for collectors.",
    imageUrl: "operation-phoenix-weapon-case.png",
    inStock: true,
    onSale: true,
    urlGame: "operation-phoenix-weapon-case.png",
  },
  {
    id: 14,
    productName: "Osrs Rs3 Bonds Webp",
    price: 40.0,
    oldPrice: 0,
    description: "Bonds for RuneScape.",
    imageUrl: "osrs-rs3-bonds.webp",
    inStock: true,
    onSale: false,
    urlGame: "osrs-rs3-bonds.webp",
  },
  {
    id: 15,
    productName: "10 Points Z Dragon Ball Z Budokai Tenkaichi 3",
    price: 0.7,
    oldPrice: 2.0,
    description:
      "10 DBZ points pack. Unlock exclusive content, new characters, and powerful abilities to enhance your fighting experience in Dragon Ball Z Budokai Tenkaichi 3. Dominate your foes.",
    imageUrl: "points-dragon-ball-z-budokai-tenkaichi-3.png",
    inStock: true,
    onSale: true,
    urlGame: "points-dragon-ball-z-budokai-tenkaichi-3.png",
  },
  {
    id: 16,
    productName: "50 Points Z Dragon Ball Z Budokai Tenkaichi 3",
    price: 3.32,
    oldPrice: 0,
    description:
      "50 DBZ points pack. Unlock exclusive content, new characters, and powerful abilities to enhance your fighting experience in Dragon Ball Z Budokai Tenkaichi 3. Dominate your foes with ease.",
    imageUrl: "points-dragon-ball-z-budokai-tenkaichi-3.png",
    inStock: true,
    onSale: false,
    urlGame: "points-dragon-ball-z-budokai-tenkaichi-3.png",
  },
  {
    id: 17,
    productName: "100 Points Z Dragon Ball Z Budokai Tenkaichi 3",
    price: 5.5,
    oldPrice: 0,
    description:
      "100 DBZ points pack. Unlock exclusive content, new characters, and powerful abilities to enhance your fighting experience in Dragon Ball Z Budokai Tenkaichi 3. Dominate your foes.",
    imageUrl: "points-dragon-ball-z-budokai-tenkaichi-3.png",
    inStock: true,
    onSale: false,
    urlGame: "points-dragon-ball-z-budokai-tenkaichi-3.png",
  },
  {
    id: 18,
    productName: "500 Points Z Dragon Ball Z Budokai Tenkaichi 3",
    price: 25.0,
    oldPrice: 30,
    description: "500 DBZ points pack.",
    imageUrl: "points-dragon-ball-z-budokai-tenkaichi-3.png",
    inStock: true,
    onSale: true,
    urlGame: "points-dragon-ball-z-budokai-tenkaichi-3.png",
  },
  {
    id: 19,
    productName: "1000 Points Z Dragon Ball Z Budokai Tenkaichi 3",
    price: 44.99,
    oldPrice: 50.0,
    description:
      "1000 DBZ points pack. Unlock exclusive content, new characters, and powerful abilities to enhance your fighting experience in Dragon Ball Z Budokai Tenkaichi 3. Dominate your foes.",
    imageUrl: "points-dragon-ball-z-budokai-tenkaichi-3.png",
    inStock: true,
    onSale: true,
    urlGame: "points-dragon-ball-z-budokai-tenkaichi-3.png",
  },
  {
    id: 20,
    productName: "Skill Injector Large Skill Injector",
    price: 180.0,
    oldPrice: 0,
    description:
      "Large skill injector. Boost your character's abilities instantly with this powerful injector. Accelerate your progress and unlock new potentials. Essential for advanced players.",
    imageUrl: "skill-injector-large-skill-injector.png",
    inStock: true,
    onSale: false,
    urlGame: "skill-injector-large-skill-injector.png",
  },
  {
    id: 21,
    productName: "Sword Courageous Fatebreak",
    price: 1100.0,
    oldPrice: 1250.0,
    description:
      "Legendary sword that breaks destinies. Wield this mighty blade to overcome any challenge and forge your own path. Its power is unmatched in battle.",
    imageUrl: "sword-courageous-fatebreak.png",
    inStock: true,
    onSale: true,
    urlGame: "sword-courageous-fatebreak.png",
  },
  {
    id: 22,
    productName: "10 Tibia Coins",
    price: 0.7,
    oldPrice: 0,
    description: "Pack of 10 Tibia Coins.",
    imageUrl: "tibia-coins.png",
    inStock: true,
    onSale: false,
    urlGame: "tibia-coins.png",
  },
  {
    id: 23,
    productName: "50 Tibia Coins",
    price: 3.0,
    oldPrice: 4.5,
    description:
      "Pack of 50 Tibia Coins. Elevate your in-game experience with this valuable currency. Unlock premium features, rare items, and special services. Your ultimate Tibia adventure awaits.",
    imageUrl: "tibia-coins.png",
    inStock: true,
    onSale: true,
    urlGame: "tibia-coins.png",
  },
  {
    id: 24,
    productName: "100 Tibia Coins",
    price: 5.5,
    oldPrice: 0,
    description: "Pack of 100 Tibia Coins.",
    imageUrl: "tibia-coins.png",
    inStock: true,
    onSale: false,
    urlGame: "tibia-coins.png",
  },
  {
    id: 25,
    productName: "500 Tibia Coins",
    price: 18.99,
    oldPrice: 30.0,
    description:
      "Pack of 500 Tibia Coins. Elevate your in-game experience with this valuable currency. Unlock premium features, rare items, and special services. Your ultimate Tibia adventure awaits.",
    imageUrl: "tibia-coins.png",
    inStock: true,
    onSale: true,
    urlGame: "tibia-coins.png",
  },
  {
    id: 26,
    productName: "1000 Tibia Coins",
    price: 45.0,
    oldPrice: 0,
    description: "Pack of 1000 Tibia Coins.",
    imageUrl: "tibia-coins.png",
    inStock: true,
    onSale: false,
    urlGame: "tibia-coins.png",
  },
  {
    id: 27,
    productName: "Twisted Bow",
    price: 2400.0,
    oldPrice: 1555.0,
    description:
      "Twisted bow of great power. An unparalleled weapon known for its immense accuracy and devastating damage against magical foes. A game-changer for any archer.",
    imageUrl: "twisted-bow.png",
    inStock: true,
    onSale: true,
    urlGame: "twisted-bow.png",
  },
  {
    id: 28,
    productName: "White Partyhat",
    price: 1699.99,
    oldPrice: 0,
    description: "An elegant white party hat.",
    imageUrl: "white-partyhat.png",
    inStock: true,
    onSale: false,
    urlGame: "white-partyhat.png",
  },
  {
    id: 29,
    productName: "World Lock",
    price: 10.32,
    oldPrice: 12.5,
    description:
      "Locks your world securely. Protect your valuable creations and resources from unauthorized access. An essential item for building and securing your virtual domain.",
    imageUrl: "world-lock.png",
    inStock: true,
    onSale: true,
    urlGame: "world-lock.png",
  },
  {
    id: 30,
    productName: "Armageddon Weapon Scroll",
    price: 850.0,
    oldPrice: 0,
    description:
      "A powerful legendary weapon scroll. Unlocks devastating abilities for your weapon, granting unparalleled strength in combat. Essential for conquering the toughest challenges and foes.",
    imageUrl: "armageddon-weapon-scroll.png",
    inStock: true,
    onSale: false,
    urlGame: "armageddon-weapon-scroll.png",
  },
  {
    id: 31,
    productName: "Chroma 3 Case",
    price: 1.34,
    oldPrice: 2.0,
    description:
      "Chroma 3 case with rare items. Unlock a collection of vibrant and exclusive weapon skins and cosmetic items. Each case offers a chance at truly unique gear.",
    imageUrl: "chroma-3-case.png",
    inStock: true,
    onSale: true,
    urlGame: "chroma-3-case.png",
  },
  {
    id: 32,
    productName: "Creatures Of Sonaria Maiuve",
    price: 75.44,
    oldPrice: 88.85,
    description: "Exotic creature from Sonaria, Maiuve.",
    imageUrl: "creatures-of-sonaria-maiuve.png",
    inStock: true,
    onSale: true,
    urlGame: "creatures-of-sonaria-maiuve.png",
  },
  {
    id: 33,
    productName: "Creatures Of Sonaria Tornir",
    price: 60.0,
    oldPrice: 69.99,
    description:
      "Mystical creature from Sonaria, Tornir. A rare and powerful companion, known for its unique abilities and stunning appearance. Perfect for dedicated collectors and adventurers.",
    imageUrl: "creatures-of-sonaria-tornir.png",
    inStock: true,
    onSale: true,
    urlGame: "creatures-of-sonaria-tornir.png",
  },
  {
    id: 34,
    productName: "Falchion Case Key",
    price: 2.01,
    oldPrice: 0,
    description: "Key to open the Falchion case.",
    imageUrl: "falchion-case-key.png",
    inStock: true,
    onSale: false,
    urlGame: "falchion-case-key.png",
  },
  {
    id: 35,
    productName: "FF14 Demi Ozma Mount",
    price: 450.01,
    oldPrice: 500.0,
    description:
      "Exclusive Final Fantasy XIV mount. Ride into battle or traverse the lands on the back of this magnificent and rare creature. A symbol of prestige and accomplishment.",
    imageUrl: "ff14-demi-ozma-mount.png",
    inStock: true,
    onSale: true,
    urlGame: "ff14-demi-ozma-mount.png",
  },
  {
    id: 36,
    productName: "Grand Piece Online",
    price: 25.34,
    oldPrice: 27,
    description: "Pirate adventure in Grand Piece Online.",
    imageUrl: "grand-piece-online.png",
    inStock: true,
    onSale: true,
    urlGame: "grand-piece-online.png",
  },
  {
    id: 37,
    productName: "Oathplate Helm",
    price: 120.14,
    oldPrice: 149.99,
    description:
      "Resilient oathplate helmet. Provides superior defense and protection in fierce battles. Essential headwear for warriors seeking maximum resilience and battlefield advantage. A true guardian's piece.",
    imageUrl: "oathplate-helm.webp",
    inStock: true,
    onSale: true,
    urlGame: "oathplate-helm.webp",
  },
  {
    id: 38,
    productName: "Oathplate Legs",
    price: 104.36,
    oldPrice: 0,
    description: "Oathplate armor legs.",
    imageUrl: "oathplate-legs.webp",
    inStock: true,
    onSale: false,
    urlGame: "oathplate-legs.webp",
  },
  {
    id: 39,
    productName: "Pet Simulator 99 Huge Cosmic",
    price: 1806.87,
    oldPrice: 1949.99,
    description:
      "Giant cosmic pet for Pet Simulator 99. A rare and powerful companion that provides massive boosts to your in-game progress. Dominate the game with this colossal ally.",
    imageUrl: "pet-simulator-99-huge-cosmic.png",
    inStock: true,
    onSale: true,
    urlGame: "pet-simulator-99-huge-cosmic.png",
  },
  {
    id: 40,
    productName: "Pet Simulator 99 Huge Nightfall",
    price: 2000.0,
    oldPrice: 2099.99,
    description: "Giant nightfall pet.",
    imageUrl: "pet-simulator-99-huge-nightfall.png",
    inStock: true,
    onSale: true,
    urlGame: "pet-simulator-99-huge-nightfall.png",
  },
  {
    id: 41,
    productName: "Pet Simulator 99 Huge Nightmare",
    price: 2199.99,
    oldPrice: 0,
    description:
      "Huge nightmare pet for Pet Simulator 99. This colossal companion offers immense power and boosts for your in-game progress. A terrifyingly effective ally.",
    imageUrl: "pet-simulator-99-huge-nightmare.png",
    inStock: true,
    onSale: false,
    urlGame: "pet-simulator-99-huge-nightmare.png",
  },
  {
    id: 42,
    productName: "Pet Simulator 99 Huge Party",
    price: 1900.0,
    oldPrice: 2100,
    description: "Giant party pet.",
    imageUrl: "pet-simulator-99-huge-party.png",
    inStock: true,
    onSale: true,
    urlGame: "pet-simulator-99-huge-party.png",
  },
  {
    id: 43,
    productName: "Pet Simulator 99 Huge Tech",
    price: 1750.0,
    oldPrice: 1880.0,
    description:
      "Giant tech pet. This advanced companion offers massive boosts to your in-game progress with its cutting-edge abilities. Dominate the game with technological supremacy. A must-have.",
    imageUrl: "pet-simulator-99-huge-tech.png",
    inStock: true,
    onSale: true,
    urlGame: "pet-simulator-99-huge-tech.png",
  },
  {
    id: 44,
    productName: "Survive The Killer Cold Heart",
    price: 150.0,
    oldPrice: 0,
    description:
      "Survive the cold-hearted killer. Navigate treacherous environments and outsmart a relentless foe. Every step counts in this thrilling game of survival and wits. Can you escape?",
    imageUrl: "survive-the-killer-cold-heart.png",
    inStock: true,
    onSale: false,
    urlGame: "survive-the-killer-cold-heart.png",
  },
  {
    id: 45,
    productName: "Survive The Killer Cuids Heartstopper",
    price: 200.46,
    oldPrice: 0,
    description:
      "Stop the killer's heart. Confront the terrifying Cuid and put an end to his reign of terror. This item grants you a crucial advantage in facing ultimate evil.",
    imageUrl: "survive-the-killer-cuids-heartstopper.png",
    inStock: true,
    onSale: false,
    urlGame: "survive-the-killer-cuids-heartstopper.png",
  },
  {
    id: 46,
    productName: "Survive The Killer Dread",
    price: 180.99,
    oldPrice: 0,
    description: "Overcome the killer's dread.",
    imageUrl: "survive-the-killer-dread.png",
    inStock: true,
    onSale: false,
    urlGame: "survive-the-killer-dread.png",
  },
  {
    id: 47,
    productName: "Survive The Killer Malvus The Magician",
    price: 220.0,
    oldPrice: 250.0,
    description:
      "Face Malvus, the killer magician. A cunning and powerful adversary who uses dark arts to ensnare his victims. Prepare for a truly magical and terrifying encounter.",
    imageUrl: "survive-the-killer-malvus-the-magician.png",
    inStock: true,
    onSale: true,
    urlGame: "survive-the-killer-malvus-the-magician.png",
  },
  {
    id: 48,
    productName: "Survive The Killer Matilda",
    price: 190.0,
    oldPrice: 0,
    description: "Escape from Matilda, the killer.",
    imageUrl: "survive-the-killer-matilda.png",
    inStock: true,
    onSale: false,
    urlGame: "survive-the-killer-matilda.png",
  },
  {
    id: 49,
    productName: "Creatures Of Sonaria Verdant",
    price: 80.66,
    oldPrice: 95.46,
    description:
      "Vibrant creature from Sonaria, Verdant. A beautiful and rare specimen, known for its unique abilities and colorful appearance. Perfect for dedicated collectors and adventurers.",
    imageUrl: "creatures-of-sonaria-verdant.png",
    inStock: true,
    onSale: true,
    urlGame: "creatures-of-sonaria-verdant.png",
  },
  {
    id: 50,
    productName: "Fusion Dance",
    price: 75000.99,
    oldPrice: 90000.99,
    description:
      "Master the art of fusion dance like Goku and Vegeta. Combine powers to unleash devastating attacks and achieve incredible strength. A crucial technique for any serious martial artist.",
    imageUrl: "fusion-dance.jpg",
    inStock: true,
    onSale: true,
    urlGame: "fusion-dance.jpg",
  },
];
const footerSections = [
  {
    id: 1,
    title: "Chicks Gold",
    items: [
      { title: "Games", url: "#games" },
      { title: "About us", url: "#about-us" },
      { title: "Blog", url: "#blog" },
      { title: "Sitemap", url: "#sitemap" },
    ],
  },
  {
    id: 2,
    title: "Support",
    items: [
      { title: "Contact Us", url: "#contact-us" },
      { title: "FAQ", url: "#faq" },
    ],
  },
  {
    id: 3,
    title: "Legal",
    items: [
      { title: "Privacy Policy", url: "#privacy-policy" },
      { title: "Terms of Service", url: "#terms-of-service" },
      { title: "Copyright Policy", url: "#copyright-policy" },
    ],
  },
];

const navSections = [
  {
    id: 1,
    title: "CURRENCY",
    items: [
      { title: "Game Coins" },
      { title: "Virtual Money" },
      { title: "In-game Gold" },
      { title: "Premium Currency" },
      { title: "Exchange Rates" },
    ],
  },
  {
    id: 2,
    title: "ITEMS",
    items: [
      { title: "Weapons" },
      { title: "Armor" },
      { title: "Potions" },
      { title: "Tools" },
      { title: "Collectibles" },
      { title: "Consumables" },
    ],
  },
  {
    id: 3,
    title: "ACCOUNTS",
    items: [
      { title: "Game Accounts" },
      { title: "Account Boosting" },
      { title: "Account Selling" },
      { title: "Account Verification" },
      { title: "Account Recovery" },
    ],
  },
  {
    id: 4,
    title: "SERVICES",
    items: [
      { title: "Boosting Services" },
      { title: "Coaching" },
      { title: "Power Leveling" },
      { title: "Custom Orders" },
      { title: "Account Services" },
    ],
  },
  {
    id: 5,
    title: "SWAP",
    items: [
      { title: "Item Exchange" },
      { title: "Currency Swap" },
      { title: "Trade Offers" },
      { title: "Cross-Game Trades" },
    ],
  },
  {
    id: 6,
    title: "SELL",
    items: [
      { title: "Sell Items" },
      { title: "Sell Currency" },
      { title: "Sell Accounts" },
      { title: "Sell Services" },
      { title: "Create Listing" },
    ],
  },
  {
    id: 7,
    title: "USD",
    items: [
      { title: "USD" },
      { title: "EUR" },
      { title: "JPY" },
      { title: "GBP" },
      { title: "CAD" },
      { title: "AUD" },
      { title: "CHF" },
    ],
  },
];

export { products, footerSections, navSections };
